
//function AvatarController(MessageService) {
function AvatarController() {
    var ctrl = this;

    this.$onInit = function () {
        this.size = 22;
    };

    /*
    this.$onChanges = function (changes) {
        console.log('Size changed ' + this.size);
        console.log(changes);
    };
    */

    /*
    this.getAvatar = function (userID) {
        return MessageService.getAvatar(userID);
    };
    */

    this.getAvatar = function (userID) {
        //console.log('getAvatar: ' + userID);

        var avatar = '';
        if (userID) {
            avatar = userID.toLowerCase().substr(0, 2);
        }
        else {
            avatar = 'aa';
        }
        return avatar + '.png';
    };

    this.isGenesisBot = function () {
        //ctrl.userId == 'genesis@seed'
        if (ctrl.userId && ctrl.userId.toLowerCase() == 'coortexbot@seed') {
            return true;
        }
        else {
            return false;
        }
    };
}

seedWebApp.component('sdAvatar', {
    controller: AvatarController,
    bindings: {
        userId: '<',
        size: '@'
    },
    templateUrl: './SPA/components/sd-avatar.html'
});